import React, { useState } from "react";
import "../../index.css";
import "../../App.css";
import { Row, Col, DatePicker, TimePicker, Button } from "antd";
import moment from "moment";
import { Dayjs } from "dayjs";
import Typography from "antd/es/typography/Typography";

const PainDurationSelector = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);

  const handleDateChange = (date: Dayjs | null) => {
    setSelectedDate(date); // Update selected date
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-4">
        <h3 className="h3 text-theme-text-primary">
          Add a pain entry for{" "}
          {selectedDate
            ? selectedDate.format("MM/DD/YYYY")
            : moment().format("MM/DD/YYYY")}
        </h3>
        {!isEditing ? (
          <button 
            type="button"
            onClick={handleEditClick}
            className="caption2 transition-colors duration-200"
            style={{ color: 'var(--primary-500)', textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer' }}
          >
            Edit
          </button>
        ) : (
          <div className="edit-date-time flex items-center gap-2">
            <DatePicker
              className="date-time-picker-container"
              placeholder="Select Date"
              onChange={handleDateChange}
            />
            <TimePicker
              className="date-time-picker-container"
              placeholder="Select Time"
            />
          </div>
        )}
      </div>
      <p className="body1 text-theme-text-primary">
        Enter basic or detailed information
      </p>
    </div>
  );
};

export default PainDurationSelector;
